import { GameManager } from "../managers/GameManager";

export class FindTheDifferencePuzzleModel{
    questions:Array<FindTheDifferenceQuestion>;
    maxLife:number;
    fullScorePerQuestion:number;
    practiceMode:boolean;
    timeLimitPerQuestion:number;
    gameTime:number|null;

    //Gen States
    currentCorrectAnswers:number
    currentScore:number;
    currentTimeRemaining:number;
    currentQuestion:number;
    currentLife:number;
    currentGameTime:number;
    currentRound:number;
    //States
    currentGivenAnswer:Phaser.Math.Vector2|null;
    constructor(questions:Array<FindTheDifferenceQuestion>,fullScorePerQuestion:number,maxLife:number,practiceMode:boolean,timeLimitPerQuestion:number){
        this.questions = questions;
        this.maxLife = maxLife;
        this.fullScorePerQuestion = fullScorePerQuestion;
        this.practiceMode = practiceMode;
        this.timeLimitPerQuestion = timeLimitPerQuestion;
        //Initialization
        this.currentCorrectAnswers = 0;
        this.currentQuestion = 0;
        this.currentScore = 0;
        this.currentLife = this.maxLife;
        this.currentTimeRemaining = timeLimitPerQuestion;
        this.currentGivenAnswer = null;
        this.currentRound = 1;
        this.gameTime = 180;
        if((<GameManager>GameManager.instance).cbnGameConfig!.customTimeLimit != null)
        {
            this.gameTime = (<GameManager>GameManager.instance).cbnGameConfig!.customTimeLimit;
            this.gameTime = (<number>this.gameTime!)/1000;
        }
        this.currentGameTime = this.gameTime!;
    }

    getGameTime():number{
        return this.gameTime!;
    }
}

export class FindTheDifferenceQuestion{
    id:string;
    firstImageSource:string;
    secondImageSource:string;
    answerUpperLeftPosition:Phaser.Math.Vector2;
    answerLowerRightPosition:Phaser.Math.Vector2;
    firstImageKey:string;
    secondImageKey:string;

    constructor(id:string,firstImageSource:string,secondImageSource:string,answerUpperLeftPosition:Phaser.Math.Vector2,answerLowerRightPosition:Phaser.Math.Vector2){
        this.id = id;
        this.firstImageSource = firstImageSource;
        this.secondImageSource = secondImageSource;
        this.answerLowerRightPosition = answerLowerRightPosition;
        this.answerUpperLeftPosition = answerUpperLeftPosition;
        this.firstImageKey = "";
        this.secondImageKey = "";
    }

}